'use client';

import { FC, ReactNode } from 'react';
import {
  ButtonBase,
  UserAccessWithRoleCheck,
  useUserAccessControl,
} from '@bts-web/core-features/common';
import { useFeatureFlag } from '../../../../statsig/sdk/provider';
import { useModalDrawerContext } from '../../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { TradeOptionsDrawer } from '../../../../trade/TradeDrawer/TradeDrawerProper/TradeOptionsDrawer';

export const BuySellButton: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { openDrawer } = useModalDrawerContext();

  const {
    isPepFailed,
    isCoolOffActive,
    isWaitingPeriodActive,
    coolOffNeedsAA,
  } = useUserAccessControl();

  const feature_isUkLicensed = useFeatureFlag('feature_isUkLicensed');

  const isUkCoolOffRelated =
    feature_isUkLicensed &&
    (isCoolOffActive || isWaitingPeriodActive || coolOffNeedsAA);

  const handleClick = () =>
    openDrawer(TradeOptionsDrawer, {
      position: 'right',
      disableCloseButton: true,
    });

  const button = (
    <ButtonBase
      onClick={handleClick}
      size="small"
      visual="accent"
      disabled={isPepFailed && !isUkCoolOffRelated}
    >
      {children}
    </ButtonBase>
  );

  return isUkCoolOffRelated ? (
    button
  ) : (
    <UserAccessWithRoleCheck>{button}</UserAccessWithRoleCheck>
  );
};
